import { useLocation } from 'react-router-dom';
import Header from '../../common/Header/Header';
import PublishMessageForm from './component/PublishMessageForm';
import './publishMessage.scss';

const PublishNewMessage = () => {
  const location = useLocation();
  console.log(location.state, 'selected user type data');
  const userTypeSelectedValue = location.state || 'Member';
  return (
    <div className="publish-new-messge-wrapper">
      <Header
        linkTo={'/admin/Messages-Documents'}
        header="Publish New Message"
        addNewLinkTo="/admin/Messages-Documents"
        addNewHeader="VIEW ALL"
        className={'addNew'}
        buttonVarient="secondary"
        buttonPlusIconVisisble={false}
        preserveData={{ comingFrom: 'publish-new-message' }}
      />
      <div className="mt-3">
        <PublishMessageForm userTypeSelectedValue={userTypeSelectedValue} />
      </div>
    </div>
  );
};

export default PublishNewMessage;
